import React from "react";
import compromisoIcon from "@/assets/icons/compromiso.png";

const ProcessSection = () => {
  return (
    <section className="home2-process">
      <div className="home2-section-content">
        <h2 className="home2-section-title">Implicación, criterio y ritmo.</h2>
        <p className="home2-section-intro">Estamos presentes en las decisiones que importan.</p>

        <div className="home2-bento-grid">
          {/* Celda 1 — amarillo */}
          <div className="home2-bento-cell home2-bento--yellow">
            <span className="home2-bento-label">Implicación real</span>
            <p className="home2-bento-text">Entendemos el negocio, no solo los números</p>
          </div>

          {/* Celda 2 — negro */}
          <div className="home2-bento-cell home2-bento--dark">
            <span className="home2-bento-label">Ritmo mensual</span>
            <p className="home2-bento-text">El cierre financiero marca la conversación</p>
          </div>

          {/* Celda 3 — blanco, span vertical */}
          <div className="home2-bento-cell home2-bento--white">
            <span className="home2-bento-label">Criterio sénior</span>
            <p className="home2-bento-text">Experiencia aplicada, no teoría</p>
            <div className="home2-bento-pills">
              <span className="home2-bento-pill">Sin intermediarios</span>
              <span className="home2-bento-pill">Sin capas</span>
            </div>
          </div>

          {/* Celda 4 — gris, span 2 cols */}
          <div className="home2-bento-cell home2-bento--gray">
            <img src={compromisoIcon} alt="Compromiso" className="home2-bento-ceo-icon" />
            <div className="home2-bento-gray-content">
              <span className="home2-bento-label">Relación directa</span>
              <p className="home2-bento-gray-desc">Trabajamos cerca del CEO y la dirección</p>
            </div>
          </div>
        </div>

        <p className="home2-process-closing">
          Sin fricción. <span className="muted">Sin burocracia. Sin humo.</span>
        </p>
      </div>
    </section>
  );
};

export default ProcessSection;
